<template>
    <div class="container">
        <div class="canvas"></div>
    </div>
</template>

<script>
import { gsap } from 'gsap';

export default {
    mounted() {
        const initDelay = 1.5;
        gsap.delayedCall(initDelay, () => {
            // Let's make something cool!
            const {
                _: { debounce },
                Matter: {
                    Body,
                    Render,
                    Engine,
                    World,
                    Bodies,
                    Events,
                    Mouse,
                    MouseConstraint,
                    Composite
                }
            } = window;
            // eslint-disable-next-line

            const desktopMultiplier = (window.innerWidth * 0.004);
            let multiplier = window.matchMedia('(max-width: 767px)').matches
                ? 2
                : desktopMultiplier;

            const TEXTURES = [
                {
                    url: '/media/images/5.svg',
                    width: 42 * multiplier,
                    height: 60 * multiplier
                },
                {
                    url: '/media/images/1.svg',
                    width: 20 * multiplier,
                    height: 58 * multiplier
                },
                {
                    url: '/media/images/N.svg',
                    width: 45 * multiplier,
                    height: 62 * multiplier
                },
                {
                    url: '/media/images/O.svg',
                    width: 61 * multiplier,
                    height: 61 * multiplier
                },
                {
                    url: '/media/images/R.svg',
                    width: 43 * multiplier,
                    height: 60 * multiplier
                },
                {
                    url: '/media/images/T.svg',
                    width: 45 * multiplier,
                    height: 58 * multiplier
                },
                {
                    url: '/media/images/H.svg',
                    width: 45 * multiplier,
                    height: 58 * multiplier
                }
            ];

            const canvas = document.querySelector('#someId');

            const engine = Engine.create({
                // enableSleeping: true
            });

            const render = Render.create({
                element: '.scene',
                canvas,
                engine: engine,
                options: {
                    background: 'transparent',
                    wireframeBackground: 'transparent',
                    wireframes: false,
                    width: window.innerWidth,
                    height: window.innerHeight
                }
            });

            // Create the ground
            const ground = Bodies.rectangle(
                -100,
                window.innerHeight - 5,
                window.innerWidth * 5,
                1,
                {
                    isStatic: true,
                    render: {
                        opacity: 0
                    }
                }
            );

            const leftGround = Bodies.rectangle(
                -100,
                window.innerHeight - 5,
                1,
                window.innerHeight * 5,
                {
                    isStatic: true,
                    render: {
                        opacity: 0
                    }
                }
            );

            const rightGround = Bodies.rectangle(
                window.innerWidth + 100,
                window.innerHeight - 5,
                1,
                window.innerHeight * 5,
                {
                    isStatic: true,
                    render: {
                        opacity: 0
                    }
                }
            );

            // add all of the bodies to the world
            World.add(engine.world, [ground, leftGround, rightGround]);

            // run the engine
            Engine.run(engine);

            // run the renderer
            Render.run(render);

            var mouse = Mouse.create(render.canvas),
                mouseConstraint = MouseConstraint.create(engine, {
                    mouse: mouse,
                    constraint: {
                        stiffness: 0.2,
                        render: {
                            visible: false
                        }
                    }
                });
            
            mouseConstraint.mouse.element.removeEventListener("mousewheel", mouseConstraint.mouse.mousewheel);
            mouseConstraint.mouse.element.removeEventListener("DOMMouseScroll", mouseConstraint.mouse.mousewheel);

            Composite.add(engine.world, mouseConstraint);

            // keep the mouse in sync with rendering
            render.mouse = mouse;

            const addBear = () => {
                const HEADS = [];
                const amount = 7;

                for (let h = 0; h < amount; h++) {
                    const texture = TEXTURES[h];
                    const MULTI = multiplier;
                    const HEAD = Bodies.rectangle(
                        gsap.utils.random(0, window.innerWidth),
                        -750,
                        texture.width,
                        texture.height,
                        {
                            angle: gsap.utils.random(0, 360) * (Math.PI / 180),
                            render: {
                                strokeStyle: '#ffffff',
                                sprite: {
                                    texture: texture.url,
                                    xScale: 1 * MULTI,
                                    yScale: 1 * MULTI
                                }
                            }
                        }
                    );

                    if (Math.random() > 0.5) {
                        gsap.to(HEAD, {
                            angle: 0,
                            repeat: 0,
                            duration: gsap.utils.random(0.2, 2)
                        });
                    }

                    // Events.on(HEAD, 'sleepStart', () => {
                    //     // World.remove(engine.world, HEAD);
                    //     // if (engine.world.bodies.length < 80) mixed();
                    // });

                    HEADS.push(HEAD);
                }
                World.add(engine.world, HEADS);
            };

            const mixed = () => addBear();
            const clear = () => World.clear(engine.world, true);

            // document.body.addEventListener('click', mixed);
            if (window.matchMedia('(min-width: 768px)').matches) {
                window.addEventListener(
                    'resize',
                    debounce(() => {
                        World.clear(engine.world, true);
                        canvas.width = window.innerWidth;
                        canvas.height = window.innerHeight;

                        const desktopMultiplier = (window.innerWidth * 0.004);
                        multiplier = window.matchMedia('(max-width: 767px)').matches
                            ? 2
                            : desktopMultiplier;
                        
                        Body.setPosition(ground, {
                            x: 0,
                            y: window.innerHeight - 10
                        });
                        mixed();
                    }, 500)
                );
            }


            mixed();
        });
    }
};
</script>

<style>
#someId {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    /* background-color: white; */
    z-index: 100;
    pointer-events: none;


}

    @media only screen and (min-width: 768px)  {
        #someId {
            pointer-events: initial;
        }
    }
</style>
